// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__lC6F2","content":"ManualTimeModal_content__3KMCk"};